<div class="modal-header">
    <h4 class="m-0 mt-1 font-weight-bold text-primary float-left pb-2">{{'entity.user.changePassword.tittle' | translate}}</h4>
    <button *ngIf="!modal" type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<form [formGroup]="detailForm" autocomplete="off" (ngSubmit)="changePassword()">
    <div class="modal-body">
        <div class="row">
            <!-- Formulario -->
            <div class="col-sm-12 col-md-12 col-lg-12"
            [ngClass]="(this.user.type === userCV.TYPE_PORTAL_OCS ? 'col-xl-12' : 'col-xl-6')">
                <!-- Clave anterior-->
                <div *ngIf="!this.afterLogin" class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                        <label for="previousPassword" class="required">{{'entity.user.field.previous.password.label' | translate}}</label>
                        <div class="input-group">
                            <input 
                                type="password"
                                #firstFocusInsert
                                id="previousPassword" 
                                formControlName="previousPassword" 
                                placeholder="{{'entity.user.field.previous.password.placeHolder' | translate}}" 
                                class="form-control form-control-user" 
                                (keydown.space)="$event.preventDefault();"
                                appInputPassword
                            />
                        </div>
                        <app-form-error [form]="detailForm" controlName="previousPassword" [required]="true"></app-form-error>
                    </div>
                </div>
                <!-- Clave 1-->
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
                        <label for="password" class="required">{{'entity.user.field.new.password.label' | translate}}</label>
                        <div class="input-group">
                            <input 
                                type="password"
                                id="password" 
                                #firstFocusInsert
                                formControlName="password" 
                                placeholder="{{'entity.user.field.password.placeHolder' | translate}}" 
                                class="form-control form-control-user" 
                                aria-describedby="inputGroupPrepend"
                                (change)="updateAndValidityControl(detailForm, 'password');updateAndValidityControl(detailForm, 'repeatpassword')"
                                (keydown.space)="$event.preventDefault();"
                                
                                appInputPassword
                            />
                        </div>
                        <app-form-error [form]="detailForm" controlName="password" [required]="true"></app-form-error>
                    </div>
                </div>
                <!-- Clave 2-->
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
                        <label for="repeatpassword" class="required">{{'entity.user.field.repeat.password.label' | translate}}</label>
                        <div class="input-group">
                            <input 
                                type="password"
                                id="repeatpassword" 
                                formControlName="repeatpassword" 
                                placeholder="{{'entity.user.field.repeat.password.placeHolder' | translate}}" 
                                class="form-control form-control-user" 
                                aria-describedby="inputGroupPrepend"
                                (keydown.space)="$event.preventDefault();"
                                appInputPassword
                            />
                        </div>
                        <app-form-error [form]="detailForm" controlName="repeatpassword" [required]="true"></app-form-error>
                    </div>
                </div>
            </div>
            <div *ngIf="this.user.type !== userCV.TYPE_PORTAL_OCS" class="col-sm-12 col-md-12 col-lg-12 col-xl-6 my-1">
                <div class="card border-primary col-12">
                    <h5 class="m-0 mt-1 font-weight-bold text-primary float-left">{{'entity.user.changePassword.requirements.tittle' | translate}}</h5>
                    <ul class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ml-2 mt-2">
                        <li><small>{{'entity.user.changePassword.requirements.length' | translate}}</small></li>
                        <li><small>{{'entity.user.changePassword.requirements.lowerCase' | translate}}</small></li>
                        <li><small>{{'entity.user.changePassword.requirements.upperCase' | translate}}</small></li>
                        <li><small>{{'entity.user.changePassword.requirements.number' | translate}}</small></li>
                        <li><small>{{'entity.user.changePassword.requirements.special' | translate}}</small></li>
                        <li><small>{{'entity.user.changePassword.requirements.notSamePrevousPassword' | translate}}</small></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="!modal" type="button" class="btn btn-secondary" (click)="close()">{{ 'common.cancel' | translate }}</button>
        <button type="submit" class="btn btn-primary float-right mb-2" [disabled]="!this.detailForm.valid">{{'entity.user.changePassword.buttons.changePassword' | translate}}</button>
    </div>
</form>
